export default "__VITE_ASSET__43fb6074__"